<template>
	<div class="page-qrcode page-content" v-loading="body_loading">
		<div class="main-body">
			<el-row class="hd">
				<el-col :span="12">
					<h3 style="float: none;">免费出场二维码</h3>
					<div class="flex-block breadcrumb-box">
						<div class="position-text">位置：</div>
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item>二维码管理</el-breadcrumb-item>
							<el-breadcrumb-item>免费出场二维码</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
				</el-col>
			</el-row>
			<div class="bd">
				<div class="qrcode-container">
					<div class="qrcode-wrapper" v-if="qrcodeUrl">
						<div class="qrcode-title">免费出场二维码</div>
						<div class="qrcode-image">
							<img :src="qrcodeUrl" alt="免费出场二维码" />
						</div>
						<div class="qrcode-tips">
							<p>请扫描二维码进行免费出场</p>
							<p class="refresh-time">二维码将在 {{ countdown }} 秒后自动刷新</p>
						</div>
					</div>
					<div class="qrcode-error" v-else-if="errorMessage">
						<el-alert
							:title="errorMessage"
							type="error"
							:closable="false"
							show-icon>
						</el-alert>
						<el-button type="primary" @click="getQrcode" style="margin-top: 20px;">重新获取</el-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'freeExitQrcode',
	data() {
		return {
			body_loading: false,
			qrcodeUrl: '',
			errorMessage: '',
			refreshInterval: null,
			countdownInterval: null,
			countdown: 300, // 5分钟 = 300秒
			refreshTime: 300000 // 5分钟 = 300000毫秒
		}
	},
	created() {
		document.title = '免费出场二维码';
		this.getQrcode();
		this.startAutoRefresh();
	},
	beforeDestroy() {
		// 清除定时器
		if (this.refreshInterval) {
			clearInterval(this.refreshInterval);
		}
		if (this.countdownInterval) {
			clearInterval(this.countdownInterval);
		}
	},
	methods: {
		getQrcode() {
			var _this = this;
			_this.body_loading = true;
			_this.errorMessage = '';

			// 调用接口获取二维码
			var params = {
				path: 'parking/parkingFree/parkingFree', // 根据实际需求修改小程序页面路径
				// path: 'pages/index/index', // 根据实际需求修改小程序页面路径
				query: 'type=freeExit' // 根据实际需求修改查询参数
			};

			this.$client.get('/api/wx/qrcode/generateUrlLink', params, function(res, message) {
				_this.body_loading = false;
				if (res) {
					_this.qrcodeUrl = res;
					_this.resetCountdown();
				} else {
					_this.errorMessage = message || '获取二维码失败';
				}
			}, function(error) {
				_this.body_loading = false;
				_this.errorMessage = error || '获取二维码失败，请稍后重试';
			});
		},
		startAutoRefresh() {
			var _this = this;
			// 每5分钟刷新一次二维码
			_this.refreshInterval = setInterval(function() {
				_this.getQrcode();
			}, _this.refreshTime);

			// 每秒更新倒计时
			_this.countdownInterval = setInterval(function() {
				if (_this.countdown > 0) {
					_this.countdown--;
				} else {
					_this.countdown = 300;
				}
			}, 1000);
		},
		resetCountdown() {
			this.countdown = 300;
		}
	}
}
</script>

<style scoped>
.qrcode-container {
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 500px;
	padding: 40px 20px;
}

.qrcode-wrapper {
	background: #fff;
	border-radius: 8px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	padding: 40px;
	text-align: center;
	max-width: 500px;
	width: 100%;
}

.qrcode-title {
	font-size: 24px;
	font-weight: bold;
	color: #303133;
	margin-bottom: 30px;
}

.qrcode-image {
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: 30px;
}

.qrcode-image img {
	max-width: 300px;
	width: 100%;
	height: auto;
	border: 1px solid #DCDFE6;
	border-radius: 4px;
	padding: 10px;
}

.qrcode-tips {
	color: #606266;
	font-size: 14px;
}

.qrcode-tips p {
	margin: 10px 0;
}

.refresh-time {
	color: #909399;
	font-size: 12px;
}

.qrcode-error {
	text-align: center;
}
</style>
